import { Link } from 'react-router-dom';
import StaticPageLayout from '@/components/layout/StaticPageLayout';
import andyImg from '@/images/andy.png';
import distressedImg from '@/images/distressed.png';
import gustavoImg from '@/images/gustavo-trotta.png';
import trippAndRandyImg from '@/images/tripp_and_randy.png';
import jorgesImg from '@/images/jorges.png';
import saviaImg from '@/images/savia-rocks.png';
import whatsInAMoveImg from '@/images/whats_in_a_move.png';
import plusIcon from '@/images/plus.svg';
import boltIcon from '@/images/lightning.svg';
import arrowIcon from '@/images/arrow.svg';
import advisor1Img from '@/images/clay.png';
import advisor2Img from '@/images/shawn.png';
import advisor3Img from '@/images/jasper.png';
import advisor4Img from '@/images/judd.png';
import advisor5Img from '@/images/alli.png';
import advisor6Img from '@/images/ryan.png';
import advisor7Img from '@/images/ron.png';
import advisor8Img from '@/images/mark_lind.png';

export default function LandingPage() {
  return (
    <StaticPageLayout>
      {/* ============ HERO SECTION ============ */}
      <section
        className="relative z-[8] flex min-h-[80vh] flex-col items-center justify-center bg-cover bg-center px-5 pb-[calc(80px+50px)] pt-[120px] text-center md:pb-[calc(80px+80px)] [clip-path:polygon(0_0,100%_0,100%_calc(100%-50px),0_100%)] md:[clip-path:polygon(0_0,100%_0,100%_calc(100%-80px),0_100%)]"
        style={{ backgroundImage: `url(${andyImg})` }}
      >
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/60" />

        <div className="relative z-10 max-w-[800px]">
          <h1 className="font-heading text-[48px] uppercase leading-[1] tracking-[2px] text-white md:text-[85px] md:leading-[85px] [text-shadow:_-1px_-1px_0_#000,_1px_-1px_0_#000,_-1px_1px_0_#000,_1px_1px_0_#000]">
            MUSICIANS, STOP GUESSING YOUR NEXT MOVE
          </h1>
          <p className="mx-auto mb-8 mt-5 max-w-[800px] text-lg leading-relaxed text-white [text-shadow:_-1px_-1px_0_#000,_1px_-1px_0_#000,_-1px_1px_0_#000,_1px_1px_0_#000]">
            BandJerry gives you everything you need to get your music in front of more people. We provide tools and a clear, manageable plan. Built on hard-earned experience of musicians and music industry veterans.
          </p>
          <Link
            to="/signup"
            className="inline-block rounded bg-primary-600 px-8 py-3.5 text-base font-bold text-black no-underline transition-colors hover:bg-primary-500"
          >
            Sign Up Free
          </Link>
        </div>
      </section>

      {/* ============ FREE TOOLS — THE KIT ============ */}
      <section
        className="relative z-[6] -mt-[50px] bg-[#222] bg-cover bg-center px-6 pb-[calc(100px+50px)] pt-[calc(100px+50px)] text-center md:-mt-[80px] md:px-10 md:pb-[calc(100px+80px)] md:pt-[calc(100px+80px)] [clip-path:polygon(0_50px,100%_0,100%_calc(100%-50px),0_100%)] md:[clip-path:polygon(0_80px,100%_0,100%_calc(100%-80px),0_100%)]"
        style={{ backgroundImage: `url(${distressedImg})` }}
      >

        <h2 className="font-heading text-[48px] uppercase tracking-[2px] text-primary-600 md:text-[85px]">
          FREE PAGES FOR YOUR BAND
        </h2>
        <p className="mx-auto mb-16 mt-4 max-w-[800px] text-lg leading-relaxed text-white">
          Every BandJerry account comes with free, hosted marketing pages you can set up in minutes and share everywhere. No credit card required.
        </p>

        <div className="mx-auto flex max-w-[1200px] flex-col items-center gap-12 md:flex-row md:items-start md:justify-center md:gap-16">
          {/* Link-in-Bio */}
          <div className="max-w-[350px] flex-1 text-left">
            <div className="mb-2.5 flex items-center gap-3">
              <div className="flex h-[60px] w-[60px] flex-shrink-0 items-center justify-center">
                <svg className="h-10 w-10 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                </svg>
              </div>
              <h3 className="font-heading text-[42px] uppercase tracking-[1px] text-primary-600">LINK-IN-BIO</h3>
            </div>
            <p className="text-lg leading-relaxed text-white">
              One link that connects fans to your music, socials, merch, and more. Drop it in your Instagram bio, your email signature, or anywhere else.
            </p>
            <p className="mt-3 text-sm font-semibold uppercase tracking-wide text-primary-600">Free forever</p>
          </div>

          {/* Microsite */}
          <div className="max-w-[350px] flex-1 text-left">
            <div className="mb-2.5 flex items-center gap-3">
              <div className="flex h-[60px] w-[60px] flex-shrink-0 items-center justify-center">
                <svg className="h-10 w-10 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418" />
                </svg>
              </div>
              <h3 className="font-heading text-[42px] uppercase tracking-[1px] text-primary-600">MICROSITE</h3>
            </div>
            <p className="text-lg leading-relaxed text-white">
              A small, beautiful website for your band. Showcase your bio, upcoming shows, music, and links. No web developer needed.
            </p>
            <p className="mt-3 text-sm font-semibold uppercase tracking-wide text-primary-600">Free forever</p>
          </div>

          {/* EPK */}
          <div className="max-w-[350px] flex-1 text-left">
            <div className="mb-2.5 flex items-center gap-3">
              <div className="flex h-[60px] w-[60px] flex-shrink-0 items-center justify-center">
                <svg className="h-10 w-10 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                </svg>
              </div>
              <h3 className="font-heading text-[42px] uppercase tracking-[1px] text-primary-600">PRESS KIT</h3>
            </div>
            <p className="text-lg leading-relaxed text-white">
              A professional electronic press kit you can send to venues, promoters, and media. Bio, photos, music, and press coverage all in one place.
            </p>
            <p className="mt-3 text-sm font-semibold uppercase tracking-wide text-primary-600">Free forever</p>
          </div>
        </div>

        <Link
          to="/signup"
          className="mt-14 inline-block rounded bg-primary-600 px-8 py-3.5 text-base font-bold text-black no-underline transition-colors hover:bg-primary-500"
        >
          Create Your Free Pages
        </Link>
      </section>

      {/* ============ HOW IT WORKS ============ */}
      <section
        className="relative z-[7] -mt-[50px] bg-black bg-cover bg-center px-6 pb-[calc(100px+50px)] pt-[calc(100px+50px)] text-center md:-mt-[80px] md:px-10 md:pb-[calc(100px+80px)] md:pt-[calc(100px+80px)] [clip-path:polygon(0_50px,100%_0,100%_calc(100%-50px),0_100%)] md:[clip-path:polygon(0_80px,100%_0,100%_calc(100%-80px),0_100%)]"
        style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0.8)), url(${jorgesImg})` }}
      >
        <h2 className="font-heading text-[48px] uppercase tracking-[2px] text-primary-600 md:text-[85px]">
          HOW IT WORKS
        </h2>
        <p className="mx-auto mb-16 mt-4 max-w-[800px] text-lg leading-relaxed text-white">
          We give independent bands and musicians quick, customized moves to help them pull more people, land better gigs, and build real momentum. Moves are targeted to your stated goals and informed by your page view traffic.
        </p>

        <div className="mx-auto flex max-w-[1200px] flex-col items-center gap-12 md:flex-row md:items-start md:justify-center md:gap-16">
          {/* Step 1 */}
          <div className="max-w-[350px] flex-1 text-left">
            <div className="mb-2.5 flex items-center gap-0.5">
              <img src={plusIcon} alt="Set Your Goal" className="h-[60px] w-[60px] flex-shrink-0" />
              <h3 className="font-heading text-[42px] uppercase tracking-[1px] text-primary-600">SET YOUR GOAL</h3>
            </div>
            <p className="text-lg leading-relaxed text-white">
              Do you want to draw 50+ people at your next show, get on better playlists, or something else entirely? Tell Jerry, and he'll find ways to help.
            </p>
          </div>

          {/* Step 2 */}
          <div className="max-w-[350px] flex-1 text-left">
            <div className="mb-2.5 flex items-center gap-0.5">
              <img src={boltIcon} alt="Get A Focused Plan" className="h-[60px] w-[60px] flex-shrink-0" />
              <h3 className="font-heading text-[42px] uppercase tracking-[1px] text-primary-600">GET A FOCUSED PLAN</h3>
            </div>
            <p className="text-lg leading-relaxed text-white">
              Jerry gives you a few moves worth making now.
            </p>
          </div>

          {/* Step 3 */}
          <div className="max-w-[350px] flex-1 text-left">
            <div className="mb-2.5 flex items-center gap-0.5">
              <img src={arrowIcon} alt="Keep Moving" className="h-[60px] w-[60px] flex-shrink-0" />
              <h3 className="font-heading text-[42px] uppercase tracking-[1px] text-primary-600">KEEP MOVING</h3>
            </div>
            <p className="text-lg leading-relaxed text-white">
              Jerry follows up and adjusts the plan as you go.
            </p>
          </div>
        </div>
      </section>

      {/* ============ WHAT BANDJERRY CAN HELP WITH ============ */}
      <section
        className="relative z-[5] -mt-[50px] bg-primary-600 bg-cover bg-center px-6 pb-[calc(100px+50px)] pt-[calc(100px+50px)] md:-mt-[80px] md:px-10 md:pb-[calc(100px+80px)] md:pt-[calc(100px+80px)] [clip-path:polygon(0_50px,100%_0,100%_calc(100%-50px),0_100%)] md:[clip-path:polygon(0_80px,100%_0,100%_calc(100%-80px),0_100%)]"
        style={{ backgroundImage: `url(${gustavoImg})` }}
      >
        <div className="relative z-10 mx-auto max-w-[800px]">
          <h2 className="font-heading text-[48px] uppercase tracking-[2px] text-primary-600 md:text-[75px]">
            WHAT BANDJERRY CAN HELP WITH
          </h2>
          <p className="mb-10 mt-5 text-lg leading-relaxed text-white">
            Whether you're trying to break out of the same-club-same-crowd cycle or generate some legit momentum for your next release, BandJerry helps you figure out the smartest next step to get there.
          </p>

          <div className="space-y-6">
            <div>
              <h4 className="font-heading text-4xl uppercase tracking-[1px] text-white">DRAW MORE PEOPLE</h4>
              <p className="mt-1 text-lg leading-relaxed text-white">Turn casual listeners into people who actually come out.</p>
            </div>
            <div>
              <h4 className="font-heading text-4xl uppercase tracking-[1px] text-white">BOOK BETTER GIGS</h4>
              <p className="mt-1 text-lg leading-relaxed text-white">Find the right rooms, make stronger pitches, and build relationships that lead to new opportunities.</p>
            </div>
            <div>
              <h4 className="font-heading text-4xl uppercase tracking-[1px] text-white">GET MORE LISTENERS</h4>
              <p className="mt-1 text-lg leading-relaxed text-white">Create a manageable plan that gives your music a better chance of reaching the right people.</p>
            </div>
            <div>
              <h4 className="font-heading text-4xl uppercase tracking-[1px] text-white">GROW BEYOND YOUR LOCAL SCENE</h4>
              <p className="mt-1 text-lg leading-relaxed text-white">Identify promising cities, make the right connections, and expand without wasting time or money.</p>
            </div>
            <div>
              <h4 className="font-heading text-4xl uppercase tracking-[1px] text-white">BUILD COMMUNITY</h4>
              <p className="mt-1 text-lg leading-relaxed text-white">Find more ways to connect with the people most likely to care about your music and stick around.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ============ BUILT BY PEOPLE ============ */}
      <section
        className="relative z-[4] -mt-[50px] bg-[#111] bg-cover bg-center px-6 pb-[calc(100px+50px)] pt-[calc(100px+50px)] text-center md:-mt-[80px] md:px-10 md:pb-[calc(100px+80px)] md:pt-[calc(100px+80px)] [clip-path:polygon(0_50px,100%_0,100%_calc(100%-50px),0_100%)] md:[clip-path:polygon(0_80px,100%_0,100%_calc(100%-80px),0_100%)]"
        style={{ backgroundImage: `url(${distressedImg})` }}
      >
        <div className="relative z-10 mx-auto max-w-[800px]">
          <div className="mx-auto mb-4 h-[300px] w-[300px] overflow-hidden rounded-full border-[3px] border-primary-600 md:h-[360px] md:w-[360px]">
            <img src={trippAndRandyImg} alt="Tripp and Randy" className="h-full w-full object-cover" />
          </div>
          <h2 className="font-heading text-[48px] uppercase leading-[0.95] tracking-[2px] text-primary-600 md:text-[85px]">
            BUILT BY PEOPLE WHO HAVE ACTUALLY BEEN THERE
          </h2>
          <p className="mt-8 text-lg leading-[1.7] text-white">
            BandJerry was founded by two guys with wildly different, but oddly complementary, resumes. A touring musician/marketing executive and an AI engineer. Both in a band together. Writers of music and lyrics, code and cold emails to venues.
          </p>
          <p className="mt-5 text-lg leading-[1.7] text-white">
            We've played empty rooms, packed-out theaters, and corporate boardrooms. We put years of learning into what actually helps a band grow and merged those experiences with the expertise we use from our day jobs.
          </p>
          <Link
            to="/signup"
            className="mt-8 inline-block rounded border-2 border-primary-600 px-8 py-3 text-sm font-semibold text-primary-600 no-underline transition-colors hover:bg-primary-600 hover:text-black"
          >
            Start Free — Your First 3 Moves Are On Us
          </Link>
        </div>
      </section>

      {/* ============ DIFFERENT PERSPECTIVES ============ */}
      <section
        className="relative z-[3] -mt-[50px] bg-black bg-cover bg-center px-6 pb-[calc(100px+50px)] pt-[calc(100px+50px)] text-center md:-mt-[80px] md:px-10 md:pb-[calc(100px+80px)] md:pt-[calc(100px+80px)] [clip-path:polygon(0_50px,100%_0,100%_calc(100%-50px),0_100%)] md:[clip-path:polygon(0_80px,100%_0,100%_calc(100%-80px),0_100%)]"
        style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0.8)), url(${jorgesImg})` }}
      >
        <h2 className="font-heading text-[48px] uppercase leading-[0.95] tracking-[2px] text-primary-600 md:text-[85px]">
          DIFFERENT PERSPECTIVES FOR<br className="hidden md:block" /> DIFFERENT GOALS
        </h2>
        <p className="mx-auto mb-4 mt-5 max-w-[900px] text-lg leading-[1.7] text-white">
          There's no single way to grow a band. What works depends on your goals, your style, your scene, and the resources you have. Our Band of Advisors brings a wide range of real-world perspectives to cross-check context-specific advice against larger patterns that hold up across scenes and genres.
        </p>
        <p className="mx-auto mb-16 max-w-[900px] text-lg leading-[1.7] text-white">
          The result is moves with more range, nuance, and judgment than you'll get anywhere else on the Internet.
        </p>
        
        <div className="mx-auto flex max-w-[800px] flex-wrap justify-center gap-x-6 gap-y-8 md:gap-x-10 md:gap-y-10">

          <div className="w-[calc(50%-12px)] text-center md:w-[calc(33.333%-27px)]">
            <div className="mx-auto mb-4 h-[130px] w-[130px] overflow-hidden rounded-full border-[3px] border-primary-600 md:h-[200px] md:w-[200px]">
              <img src={advisor1Img} alt="Advisor 1" className="h-full w-full object-cover" />
            </div>
            <h4 className="text-lg text-white">C.F.</h4>
            <p className="text-lg italic text-white">Promoter</p>
          </div>

          <div className="w-[calc(50%-12px)] text-center md:w-[calc(33.333%-27px)]">
            <div className="mx-auto mb-4 h-[130px] w-[130px] overflow-hidden rounded-full border-[3px] border-primary-600 md:h-[200px] md:w-[200px]">
              <img src={advisor2Img} alt="Shawn Flores" className="h-full w-full object-cover" />
            </div>
            <h4 className="text-lg text-white">S.F.</h4>
            <p className="text-lg italic text-white">Merch Manufacturer</p>
          </div>

          <div className="w-[calc(50%-12px)] text-center md:w-[calc(33.333%-27px)]">
            <div className="mx-auto mb-4 h-[130px] w-[130px] overflow-hidden rounded-full border-[3px] border-primary-600 md:h-[200px] md:w-[200px]">
              <img src={advisor3Img} alt="Advisor 1" className="h-full w-full object-cover" />
            </div>
            <h4 className="text-lg text-white">J.M.</h4>
            <p className="text-lg italic text-white">Venue Owner/Touring Musician/Club Bartender</p>
          </div>

          <div className="w-[calc(50%-12px)] text-center md:w-[calc(33.333%-27px)]">
            <div className="mx-auto mb-4 h-[130px] w-[130px] overflow-hidden rounded-full border-[3px] border-primary-600 md:h-[200px] md:w-[200px]">
              <img src={advisor4Img} alt="Advisor 1" className="h-full w-full object-cover" />
            </div>
            <h4 className="text-lg text-white">J.S.</h4>
            <p className="text-lg italic text-white">Tour Manager/Road Manager/Merch Manager</p>
          </div>

          <div className="w-[calc(50%-12px)] text-center md:w-[calc(33.333%-27px)]">
            <div className="mx-auto mb-4 h-[130px] w-[130px] overflow-hidden rounded-full border-[3px] border-primary-600 md:h-[200px] md:w-[200px]">
              <img src={advisor5Img} alt="Advisor 1" className="h-full w-full object-cover" />
            </div>
            <h4 className="text-lg text-white">A.V.</h4>
            <p className="text-lg italic text-white">Tour Manager/Tour Production</p>
          </div>

          <div className="w-[calc(50%-12px)] text-center md:w-[calc(33.333%-27px)]">
            <div className="mx-auto mb-4 h-[130px] w-[130px] overflow-hidden rounded-full border-[3px] border-primary-600 md:h-[200px] md:w-[200px]">
              <img src={advisor6Img} alt="Advisor 1" className="h-full w-full object-cover" />
            </div>
            <h4 className="text-lg text-white">R.A.</h4>
            <p className="text-lg italic text-white">Promoter/Booker</p>
          </div>

          <div className="w-[calc(50%-12px)] text-center md:w-[calc(33.333%-27px)]">
            <div className="mx-auto mb-4 h-[130px] w-[130px] overflow-hidden rounded-full border-[3px] border-primary-600 md:h-[200px] md:w-[200px]">
              <img src={advisor7Img} alt="Advisor 1" className="h-full w-full object-cover" />
            </div>
            <h4 className="text-lg text-white">R.M.</h4>
            <p className="text-lg italic text-white">Booking Agent/Musician</p>
          </div>

          <div className="w-[calc(50%-12px)] text-center md:w-[calc(33.333%-27px)]">
            <div className="mx-auto mb-4 h-[130px] w-[130px] overflow-hidden rounded-full border-[3px] border-primary-600 md:h-[200px] md:w-[200px]">
              <img src={advisor8Img} alt="Advisor 1" className="h-full w-full object-cover" />
            </div>
            <h4 className="text-lg text-white">M.L.</h4>
            <p className="text-lg italic text-white">Musician/Distro Owner/Promoter</p>
          </div>

        </div>
      </section>

      {/* ============ WHAT'S IN A MOVE ============ */}
      <section
        className="relative z-[2] -mt-[50px] bg-[#222] bg-cover bg-center px-6 pb-[calc(100px+50px)] pt-[calc(100px+50px)] md:-mt-[80px] md:px-10 md:pb-[calc(100px+80px)] md:pt-[calc(100px+80px)] [clip-path:polygon(0_50px,100%_0,100%_calc(100%-50px),0_100%)] md:[clip-path:polygon(0_80px,100%_0,100%_calc(100%-80px),0_100%)]"
        style={{ backgroundImage: `url(${distressedImg})` }}
      >
        <div className="mx-auto flex max-w-[1000px] flex-col items-center gap-12 md:flex-row md:items-start md:gap-16">
          <div className="flex-1">
            <h2 className="font-heading text-[48px] uppercase tracking-[2px] text-primary-600 md:text-[85px]">
              WHAT'S IN A MOVE?
            </h2>
            <p className="mt-5 text-lg leading-[1.7] text-white">
              Each <strong>Set</strong> consists of a few <strong>Moves</strong>, each one specific and manageable enough to act on right away; small, focused tasks that build toward a bigger goal.
            </p>
            <p className="mt-5 text-lg leading-[1.7] text-white">
              Depending on what you're working toward, a <strong>Set</strong> might include:
            </p>
            <ul className="mt-4 list-disc pl-5 text-lg leading-[2] text-white">
              <li>Venues and clubs that book your genre</li>
              <li>Up-to-date contact information for bookers</li>
              <li>Outreach messages and links you can send right away</li>
              <li>Similar bands or artists in your area worth connecting with</li>
              <li>Clear steps for getting your music in front of the right people</li>
            </ul>
          </div>
          <div className="w-[200px] flex-shrink-0 md:w-[250px]">
            <img
              src={whatsInAMoveImg}
              alt="What's in a Move"
              className="w-full rounded-lg shadow-[0_10px_30px_rgba(0,0,0,0.5)]"
            />
          </div>
        </div>
      </section>

      {/* ============ PRICING ============ */}
      <section
        id="cost"
        className="relative z-[1] -mt-[50px] bg-primary-600 bg-cover bg-center px-6 pb-[calc(100px+50px)] pt-[calc(100px+50px)] text-center md:-mt-[80px] md:px-10 md:pb-[calc(100px+80px)] md:pt-[calc(100px+80px)] [clip-path:polygon(0_50px,100%_0,100%_calc(100%-50px),0_100%)] md:[clip-path:polygon(0_80px,100%_0,100%_calc(100%-80px),0_100%)]"
        style={{ backgroundImage: `url(${saviaImg})` }}
      >
        <h2 className="font-heading mb-16 text-[48px] uppercase tracking-[2px] text-white md:text-[85px]">
          HOW MUCH DOES IT COST?
        </h2>

        <div className="mx-auto flex max-w-[900px] flex-col items-center justify-center gap-8 md:items-stretch md:flex-row md:gap-8">
          {/* Free */}
          <div className="relative flex w-full max-w-[270px] flex-1 flex-col rounded-lg border border-neutral-300 bg-neutral-200/80 p-8 backdrop-blur-sm">
            <h3 className="font-heading text-[42px] uppercase tracking-[1px] text-white">FREE</h3>
            <div className="mb-1 text-[65px] font-bold text-white">
              $0<span className="text-lg text-white">/mo</span>
            </div>
            <p className="mb-2 text-lg leading-relaxed text-white">Hosted pages for your band, free forever:</p>
            <ul className="mb-6 space-y-1 text-left text-base text-white">
              <li className="flex items-center gap-2">
                <span className="text-primary-600">✓</span> Link-in-Bio page
              </li>
              <li className="flex items-center gap-2">
                <span className="text-primary-600">✓</span> Microsite
              </li>
              <li className="flex items-center gap-2">
                <span className="text-primary-600">✓</span> Electronic Press Kit
              </li>
              <li className="flex items-center gap-2">
                <span className="text-primary-600">✓</span> Your first 3 Moves
              </li>
            </ul>
            <Link
              to="/signup"
              className="mt-auto block w-full rounded border-2 border-primary-600 py-3 text-center text-sm font-semibold text-primary-600 no-underline transition-colors hover:bg-primary-600 hover:text-black"
            >
              Get Started
            </Link>
          </div>

          {/* Indie */}
          <div className="relative flex w-full max-w-[270px] flex-1 flex-col rounded-lg border-[3px] border-primary-600 bg-neutral-200/80 p-8 backdrop-blur-sm">
            <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-primary-600 px-3 py-1 text-[11px] font-bold uppercase text-black">
              POPULAR
            </span>
            <h3 className="font-heading text-[42px] uppercase tracking-[1px] text-white">INDIE</h3>
            <div className="mb-1 text-[65px] font-bold text-white">
              $9<span className="text-lg text-white">/mo</span>
            </div>
            <p className="mb-6 text-lg leading-relaxed text-white">For bands ready to build real momentum.</p>
            <ul className="mb-6 space-y-1 text-left text-base text-white">
              <li className="flex items-center gap-2">
                <span className="text-primary-600">✓</span> Hosted pages
              </li>
              <li className="flex items-center gap-2">
                <span className="text-primary-600">✓</span> Page view analytics
              </li>
              <li className="flex items-center gap-2">
                <span className="text-primary-600">✓</span> Three moves/day
              </li>
            </ul>
            <Link
              to="/signup"
              className="mt-auto block w-full rounded bg-primary-600 py-3 text-center text-base font-bold text-black no-underline transition-colors hover:bg-primary-500"
            >
              Choose Indie
            </Link>
          </div>

          {/* Pro */}
          <div className="relative flex w-full max-w-[270px] flex-1 flex-col rounded-lg border border-neutral-300 bg-neutral-200/80 p-8 backdrop-blur-sm">
            <h3 className="font-heading text-[42px] uppercase tracking-[1px] text-white">PRO</h3>
            <div className="mb-1 text-[65px] font-bold text-white">
              $19<span className="text-lg text-white">/mo</span>
            </div>
            <p className="mb-6 text-lg leading-relaxed text-white">For serious artists who want every advantage.</p>
            <ul className="mb-6 space-y-1 text-left text-base text-white">
              <li className="flex items-center gap-2">
                <span className="text-primary-600">✓</span> Hosted pages
              </li>
              <li className="flex items-center gap-2">
                <span className="text-primary-600">✓</span> Page view analytics
              </li>
              <li className="flex items-center gap-2">
                <span className="text-primary-600">✓</span> Ten moves/day
              </li>
            </ul>
            <Link
              to="/signup"
              className="mt-auto block w-full rounded border-2 border-primary-600 py-3 text-center text-sm font-semibold text-primary-600 no-underline transition-colors hover:bg-primary-600 hover:text-black"
            >
              Choose Pro
            </Link>
          </div>
        </div>
      </section>
    </StaticPageLayout>
  );
}
